import { useSearchParams, useNavigate } from 'react-router-dom';
import Template1 from '@/ui/_lib/templates/Template1';
import Template2 from '@/ui/_lib/templates/Template2';
import Template3 from '@/ui/_lib/templates/Template3';
import useAuth from '@/hooks/useAuth';

function AddLinks() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { useAuthenticatedPage } = useAuth();
  useAuthenticatedPage();
  const template = searchParams.get('template') || '1';

  const handlePrevious = () => {
    navigate('/choose-template');
  };

  const handleNext = () => {
    // Navigate to preview and deploy page
    navigate(`/preview-deploy?template=${template}`);
  };

  const renderTemplate = () => {
    switch (template) {
      case '1':
        return <Template1 />;
      case '2':
        return <Template2 />;
      case '3':
        return <Template3 />;
      default:
        return <Template1 />;
    }
  };

  return (
    <div className="flex h-full w-full flex-col bg-[#F8F8FF] md:bg-white">
      {/* Header */}
      <div className="flex items-center justify-center px-4 py-6 md:px-8 md:py-8 md:bg-[#F8F8FF] md:rounded-t-[2rem]">
        <div className="text-center">
          <p className="text-sm font-medium text-gray-600 mb-1 md:text-base">Step 2</p>
          <h1 className="text-2xl font-bold text-gray-900 md:text-4xl">Add links</h1>
        </div>
      </div>

      {/* Main Content - No borders, clean layout */}
      <div className="flex-1 overflow-hidden md:bg-white md:mx-8 md:rounded-b-[2rem]">
        <div className="h-full w-full md:max-w-5xl md:mx-auto">
          <div className="h-full md:py-8 md:px-6">
            {renderTemplate()}
          </div>
        </div>
      </div>

      {/* Footer - Clean, no borders */}
      <div className="flex items-center justify-center gap-4 px-4 py-4 md:px-8 md:py-6 md:bg-[#F8F8FF] md:rounded-b-[2rem]">
        <button
          onClick={handlePrevious}
          className="flex h-12 w-[166.5px] max-w-[470px] items-center justify-center rounded-lg border border-[#039BE5] bg-transparent px-5 py-3 text-[#039BE5] transition-colors hover:bg-[#039BE5]/10 md:h-14 md:w-[200px] md:text-lg"
          type="button"
        >
          Previous
        </button>
        <button
          onClick={handleNext}
          className="flex h-12 w-[166.5px] max-w-[470px] items-center justify-center rounded-lg bg-[#039BE5] px-5 py-3 text-white transition-colors hover:bg-[#0288D1] md:h-14 md:w-[200px] md:text-lg"
          type="button"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default AddLinks;